import { render, staticRenderFns } from "./VasionFolderSelect.vue?vue&type=template&id=549987ec&scoped=true"
import script from "./VasionFolderSelect.vue?vue&type=script&lang=js"
export * from "./VasionFolderSelect.vue?vue&type=script&lang=js"
import style0 from "./VasionFolderSelect.vue?vue&type=style&index=0&id=549987ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549987ec",
  null
  
)

export default component.exports